import { loadStripe } from '@stripe/stripe-js'

let stripePromise

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(__STRIPE_PUBLIC_KEY)
  }
  return stripePromise
}

export const buildStripeError = ({error, paymentIntent}) => {
  if (!error && paymentIntent.status === 'succeeded') return null;
  let stripeError = null;
  switch (error?.type ?? 'incomplete') {
    case 'card_error':
    case 'validation_error':
      stripeError = error.message;
      break;
    case 'incomplete':
      stripeError = 'Payment not completed. Please try again.';
      break;
    case 'rate_limit_error':
      stripeError = 'Too many requests. Try again in a moment.';
      break;
    default:
      stripeError = 'Payment failed. Please try again.';
      break;
  }
  return stripeError;
}